module.exports = __webpack_public_path__ + "static/media/rank1.7b0ddbbf.svg";